import { HTTPError } from 'ky';

const PUSH_NOT_ENABLED_MESSAGE_MARKER = 'not yet enabled';

export const isPushNotEnabledError = async (error: unknown): Promise<boolean> => {
  if (!(error instanceof HTTPError) || error.response.status !== 403) return false;

  const body = await error.response.json().catch(() => null);
  return (
    typeof body?.message === 'string' && body.message.includes(PUSH_NOT_ENABLED_MESSAGE_MARKER)
  );
};
